import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "./locales/fr/translation.json";
import ar from "./locales/ar/translation.json";
import en from "./locales/en/translation.json";

i18n
  .use(LanguageDetector)    
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr }, ar: { translation: ar }, en: { translation: en } },
    fallbackLng: "fr",         
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "lang",  
    },
  });

export default i18n;